// extracted by mini-css-extract-plugin
export default {"milestones__container":"MilestoneCard_milestones__container__7XRgG","milestones__buttonsbar":"MilestoneCard_milestones__buttonsbar__K+xX2"};